import type { StyleSystemProps } from '@withjoy/joykit';
import { Box, styled } from '@withjoy/joykit';

export const StyledContainer = styled(Box)``;

export const StyledBrandLogo = styled.img`
  /* 32 / 58 */
  transform: scale(0.55);
  ${props => props.theme.mediaQueries.up({ breakpointAlias: 'md' })} {
    /* 45/58 */
    transform: scale(0.77);
  }
  ${props => props.theme.mediaQueries.up({ breakpointAlias: 'xl' })} {
    /* 65/58 */
    transform: scale(1.12);
  }

  -webkit-transition: filter 0.3s ease-in;
  -moz-transition: filter 0.3s ease-in;
  -o-transition: filter 0.3s ease-in;
  transition: filter 0.3s ease-in;

  :hover {
    filter: contrast(12%);
    cursor: pointer;
  }
  :active {
    filter: contrast(50%);
  }
`;

const containerStyles: StyleSystemProps = {
  marginX: {
    _: '-12px',
    md: 0,
  },
  paddingX: {
    _: '-10px',
    sm2: '0',
    md: 6,
    xl: '80px',
  },
  display: 'flex',
  alignItems: 'center',
};

const itemHeightStyles: StyleSystemProps = {
  height: { _: 7, md: '45px', xl: '65px' },
};

export const styles = {
  container: containerStyles,
  itemHeight: itemHeightStyles,
};
